import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_relative",
			options: [
				{
					value: 1,
					text: "Augusta"
				},
				{
					value: 2,
					text: "Farmington"
				},
				{
					value: 3,
					text: "Fort Kent"
				},
				{
					value: 4,
					text: "Machias"
				},
				{
					value: 5,
					text: "UMaine"
				},
				{
					value: 6,
					text: "Portland"
				},
				{
					value: 7,
					text: "Presque Isle"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
